<template>
<div class="page-col">
    <div class="page-main">
      <!-- Header -->
      <b-navbar class="p-0" toggleable="lg" :type="isDark ? 'dark' : 'light'" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand class="ml-4">
          <strong> Departamentos</strong>
          <small> Lista</small>
        </b-navbar-brand>



        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              
              
              
              <b-button class="px-2 " type="reset"  :variant="isDark ? 'dark' : 'light'"  @click.stop.prevent="limpar()">
                <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
              </b-button>                            
              <b-button class="px-2 border-right "  :variant="isDark ? 'dark' : 'light'" type="button"  > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>
              
              <b-form-input type="text" id="edDescricao" ref="edDescricao"
                            placeholder="Informe o Nome min(3 letras)" 
                            v-model="nome"
                            @keydown.enter="pesquisar()"
                            class=" ml-2 bg-white"> </b-form-input>                                
              
              <b-button class="ml-2 " pill type="button"  :disabled="isBusy"  variant="primary" @click.stop.prevent="pesquisar()">
                <b-icon icon="search" aria-hidden="true"></b-icon> Filtrar
              </b-button>
              <div class="d-inline-block">                              
                <b-button ref="btAdicionar" class="ml-2 " pill  variant="teal" type="button" @click.stop.prevent="novo()" > 
                  <b-icon icon="plus" aria-hidden="true" font-scale="1.2"></b-icon>  Cadastrar  
                </b-button>
              </div>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">

            <b-table 
                    class="table table-sm mb-2 "
                    id="table-transition-example"
                    ref="tbl"
                    show-empty
                    empty-text="Informe o filtro para ver os registros "
                    responsive 
                    
                    :sticky-header="stickyHeight"
                    hover 
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :dark="isDark"
                    @row-dblclicked="edit"
                    @row-clicked="clicarLinha"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <!-- Cabeçalho: ID -->
              <template #head(ID)>
                <SetFilter
                  label="ID"
                  v-model="filtros.ID"
                  :options="opcoes.ID"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <!-- Cabeçalho: Situação -->
              <template #head(SITUACAO)>
                <SetFilter
                  label="Situação"
                  v-model="filtros.SITUACAO"
                  :options="opcoes.SITUACAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(NOME)>
                <SetFilter
                  label="Nome"
                  v-model="filtros.NOME"
                  :options="opcoes.NOME"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(TIPO)>
                <SetFilter
                  label="Tipo"
                  v-model="filtros.TIPO"
                  :options="opcoes.TIPO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <!-- Cabeçalho: Situação -->
              <template #head(RESPONSAVEL)>
                <SetFilter
                  label="Responsável"
                  v-model="filtros.RESPONSAVEL"
                  :options="opcoes.RESPONSAVEL"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <b-button type="button" @click.stop="deleteItem(item.item)" size="sm" class="text-danger" :variant="isDark ? 'gray-800' : 'gray-100'" >
                  <i class="fa fa-times"></i>
                </b-button>
              </template>
              <template #cell(SITUACAO)="item">
                <b-badge pill :variant="colorirSITUACAO(item.item.SITUACAO)" >{{traduzirSITUACAO(item.item.SITUACAO)}} </b-badge>
              </template>
              <template #cell(TIPO)="item">
                <b-badge pill>{{traduzirTIPO(item.item.TIPO)}} </b-badge>
              </template>
              <!-- Alternativamente, usando custom-foot para linha de rodapé completa -->
              <template #custom-foot="{ fields, items }">
                <b-tr>
                  <b-td>Itens: ({{ itensFiltrados.length }})</b-td>
                  <b-td class="text-right font-weight-bold" v-for="(field, idx) in fields.slice(1)" :key="idx">
                    <!-- supondo que "campoValor" seja a key da coluna cujo total você quer -->
                    <span class="text-right font-weight-bold" v-if="field.key === 'TIPO'"></span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
        </b-col>
      </b-row>
    </div>  
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'

export default {
  components: {
    VueButtonSpinner,
    cSwitch,
    SetFilter
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'NOME', type: 'string', label: 'Nome' },
      { key: 'RESPONSAVEL', type: 'string', label: 'Responsavel' },
      { key: 'TIPO', type: 'string', label: 'Tipo',
        labelMap: { 'I': 'Interno', 'E': 'Externo'}},
      { key: 'SITUACAO',   type: 'string', label: 'Situação',
        labelMap: { '1': 'Ativo', '0': 'Inativo'} }
    ]
  })],

  data () {
    return {
      

      isLoading: false,
      status: '',
      isBusy: false,
      colunas: [
        { key: "ID",      label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "NOME", label: 'Nome', sortable: true, class:'align-middle', thStyle: { width: "40%" }},
        { key: "RESPONSAVEL", label: 'Responsável', sortable: true, class:'align-middle', thStyle: { width: "25%" }},
        { key: "SITUACAO", label: 'Situação', sortable: true, class:'align-middle', thStyle: { width: "10%" }},
        { key: "TIPO", label: 'Tipo', sortable: true, class:'align-middle', thStyle: { width: "10%" }},
        { key: "actions", label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: "5%" }, sortable: false }
      ]
    }
  },
  
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },

    currentPage: {
      get () {
        return this.$store.getters['departamento/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['departamento/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_FILTRO_AVANCADO", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['departamento/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_FILTRO_CABECALHO", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['departamento/ID']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_ID", value);
      }
    },
    nome: {
      get () {
        return this.$store.getters['departamento/NOME']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_NOME", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['departamento/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('departamento/SET_PER_PAGE', Number(v) || 25)
      }
    },
    lista: {
      get () {
        return this.$store.getters['departamento/LISTA']
      }, 
      set (value) {
        this.$store.commit("departamento/SET_LISTA", value);
      }
    },/*
    lista() {
      return this.$store.getters['departamento/LISTA']
    }*/
  },
  methods: {


    limparFiltros() {
      this.teste.filtros = { nome: '', cidade: '', status: '' }
    },

    clicarLinha(item) {
      this.$store.commit("departamento/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['departamento/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    colorirSITUACAO(item) { 
      return item === '1' ? 'success' : 'danger'
    },

    traduzirSITUACAO(item) { 
      return item === '1' ? 'ATIVO' : 'INATIVO'
    },
    traduzirTIPO(item) { 
      return item === 'I' ? 'INTERNO' : 'EXTERNO'
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    limparFiltro() {
      this.$store.commit("departamento/SET_LIMPAR", null);
    },
    edit (item) {
      this.$store.commit("departamento/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$router.push(`/almoxarifado/departamento/edit/${item.ID}`)
    },
    novo () {
      this.$router.push(`/almoxarifado/departamento/add`)
    },
    async pesquisar () {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('departamento/GET_LISTA')
      } catch(err) {
        this.lista = []
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível consultar os dados solicitados' )
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async deleteItem(item) {
      this.$store.commit("departamento/SET_REGISTRO_SELECIONADO_ID",item.SEQUENCIA)
      const resposta = await this.$bvModal.msgBoxConfirm(`Excluir o Cadastro: ${item.ID} : ${item.NOME} ?`, {
        title: 'Excluir?',
        size: 'sm',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (resposta == false) {
        return
      }
      let excluirPayload = {
        registro: item,
        usuario: window.localStorage.getItem('login')
      }
      try {
        this.$store.commit('controle/setAguardando', true) 
        try {
          await this.$http.post( `/api/protected/departamento/pesquisar`, excluirPayload)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        await this.$store.dispatch('departamento/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Departamento excluido com sucesso' )
        
      } finally {
        this.$store.commit('controle/setAguardando', false) 
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } else if (event.key === "Enter") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.pesquisar()
      } 
    }
  },
  async created() {
    await this.pesquisar()
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>
<style >

/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #8d99a9 !important;
  color: #fff !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #fff !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #8d99a9 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #8d99a9 !important;
}

</style>


// WEBPACK FOOTER //
// src/views/almoxarifado/departamento/DepartamentoListagem.vue